// modal.js                                        ~/js/swipers
///////////////////////////////////////////////////////////////////////////

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default (id) => {
  const ModalSwiper = new Swiper('.modal-swiper', {
    modules: [Navigation],
    slidesPerView: 1,
    initialSlide: id,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
};
